import { getDomainRole } from "./site";

export const logger = {
  debug: (...args: any[]) => {
    if (getDomainRole('user_band0').host == 'localhost') {
      console.debug('[DEBUG]', ...args);
    }
  },
  info: (...args: any[]) => {
    // if (getDomainRole('user_band0').host == 'localhost') {
    console.info('[INFO]', ...args);
    // }
  },
  error: (...args: any[]) => {
    // if (getDomainRole('user_band0').host == 'localhost') {
    console.error('[ERROR]', ...args);
    // }
  }
};